import React from 'react';
import classnames from 'classnames';
import Form, { Field } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { N90 } from '@atlaskit/theme/colors';
import './search-customer.scss';

interface Props {
  className?: string;
  onSearch: (query: string) => void;
}

interface FormData {
  query: string;
}

export const CartSearchCustomer = ({ className, onSearch }: Props) => {
  return (
    <div className={classnames('cart-search-customer', className)}>
      <Form<FormData> onSubmit={(formData) => onSearch(formData.query)}>
        {({ formProps }) => (
          <form {...formProps}>
            <Field name="query">
              {({ fieldProps }: any) => (
                <Textfield
                  {...fieldProps}
                  testId="input-search-customer"
                  placeholder="Search"
                  autoFocus={true}
                  elemBeforeInput={
                    <div className="search-icon-before" data-testId="search-icon-before">
                      <SearchIcon primaryColor={N90} label="search" size="small" />
                    </div>
                  }
                  className="cart-search-input"
                />
              )}
            </Field>
          </form>
        )}
      </Form>
    </div>
  );
};
